import React, { useState } from 'react'
import memoizeOne from 'memoize-one'

import SearchResultContainer from './SearchResultContainer'

type ResultListProps = {
  items: Item[]
  onClickMoreDetails: () => void
  loadingProducts: boolean
  intervalBegin: number
}

const ResultList = ({
  items,
  loadingProducts,
  intervalBegin,
  onClickMoreDetails,
}: ResultListProps) => {
  const [openItem, setOpenItem] = useState<string | null>(null)

  const handleToggleItem = (id: string) => () => {
    if (openItem === id) {
      setOpenItem(null)
    } else {
      setOpenItem(id)
    }
  }

  return (
    <div className="overflow-hidden br2">
      {items &&
        items.map((item, index) => (
          <SearchResultContainer
            loading={index >= intervalBegin ? loadingProducts : false}
            key={item.id}
            index={index}
            isSelectorOpen={openItem === item.id}
            item={item}
            handleToggleItem={memoizeOne(handleToggleItem)(item.id)}
            onClickMoreDetails={onClickMoreDetails}
            isUniqueItem={items.length === 1}
          />
        ))}
    </div>
  )
}

export default ResultList
